export default __webpack_public_path__ + "static/media/OGR_Login_logo.bf573ff6.png";